export default "__VITE_ASSET__GXL9Lagu__"